<template>
  <div>
    <b-modal id="modalEditHTTPServer" ref="modalEditHTTPServer"
      :title="$t('HTTP Server')" hide-footer>
      <b-overlay :show="showOverlay" rounded="sm">
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID :" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.name" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('URL')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.url" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('HTTP method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select required :options="HTTPmethods" v-model="editItem.type"></b-form-select>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditHTTPServer')" size="md"/>
      </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      showOverlay: false,
      HTTPmethods: [
        {value: 0, text: 'GET'},
        {value: 1, text: 'PUT'},
        {value: 2, text: 'POST'},
        {value: 3, text: 'DELETE'},
        {value: 4, text: 'PATCH'}
      ]
    }
  },
  methods: {
    save () {
      this.showOverlay = true
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_HTTP_SERVERS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_HTTP_SERVERS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_HTTP_SERVERS')
          this.$refs.modalEditHTTPServer.hide()
          this.$root.$emit('makeToasts')
        }
        this.showOverlay = false
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/inventory/httpServers/editModal.vue